@if (currentLanguage) {
  <div class="language-switcher">
    <button
      class="language-toggle"
      (click)="toggleDropdown()"
      [attr.aria-expanded]="isDropdownOpen"
      aria-label="Select language">
      <span class="language-code">{{ (currentLanguage.code || 'EN').toUpperCase() }}</span>
      <svg class="chevron-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    @if (isDropdownOpen) {
      <ul
        class="language-dropdown"
        [class.open]="isDropdownOpen">
        @for (lang of languages; track lang.code) {
          <li
            class="language-option"
            [class.selected]="currentLanguage && lang.code === currentLanguage.code">
            <button (click)="selectLanguage(lang)">
              <span class="language-code">{{ (lang.code || '').toUpperCase() }}</span>
              <span class="language-separator">&nbsp;&nbsp;&nbsp;</span>
              <span class="language-name">{{ lang.name }}</span>
            </button>
          </li>
        }
      </ul>
    }
  </div>
}